export default __webpack_public_path__ + "static/media/util1.96362a56.jpg";